<!--網掛掛號人員維護-->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-flex xs12>
        <v-card class="cardBgColorStyle">

            <v-card row wrap dark  color="secondary"  dense style="padding:0px 0px">

                <v-flex  d-inline-flex style="margin-bottom: -5px">
                    <v-btn @click="addItem"  dark fab top right color="accent" class="mb-2 mt-0">
                        <v-icon >mdi-plus</v-icon>
                    </v-btn>
                </v-flex>

                <!--程式名稱-->
                <v-flex d-inline-flex pl-2 style="font-size: 1.2rem;margin-bottom: -5px">
                    {{this.menuInfo.funTitle}}
                </v-flex>




            </v-card>



            <v-flex style="padding-top:1rem">
                <v-data-table
                        dense
                        :search="search"
                        id="funListTable"
                        :loading="regUserLoading"
                        :headers="regUserHeaders"
                        :items="regUserList"
                        @page-count="pagination.pageCount = $event"
                        :page.sync="pagination.page"
                        :sort-by="pagination.sortBy"
                        :sort-desc="pagination.descending"
                        :loading-text="loadingText"
                        :items-per-page="pagination.rowsPerPage"
                        hide-default-footer
                        hide-default-header
                        item-key="chart_no"
                        v-resize="resizeFunListGrid"
                        class="elevation-1">

                    <template v-slot:header="{ props }">
                        <tr class="px-1 text-left tablehead">
                            <th v-for="header in props.headers"
                                :key="header.text"
                                :class="['column sortable',pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '','px-1']"
                                @click="changeSort(header.value)">
                                <span  v-html="header.text"></span>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'none' : 'inline' : 'none'}">
                                    mdi-arrow-up
                                </v-icon>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'inline' : 'none' : 'none'}">
                                    mdi-arrow-down
                                </v-icon>
                            </th>
                        </tr>
                    </template>

                    <template slot="item" slot-scope="props" style="border: 1px solid black">
                        <!--<tr :active="props.selected" @click="props.selected = !props.selected">-->
                        <!--<td>
                          <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                        </td>-->
                        <tr>
                            <td class=" align-space-around justify-space-around fill-height px-0" >
                                <v-layout>
                                    <v-btn icon class="mx-0" @click.native.stop="editItem(props.item)"> <!---->
                                        <v-icon color="tertiary">mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon class="mx-0" @click.native.stop="deleteItem(props.item)"><!---->
                                        <v-icon color="tertiary">mdi-delete</v-icon>
                                    </v-btn>
                                </v-layout>

                            </td>
                            <td  class="px-1 text-left" style="min-width: 80px">{{ props.item.regUserId}} </td>
                            <td  class="px-1 text-left" style="min-width: 100px">{{ props.item.regUserName}}</td>
                            <td  class="px-1 text-left" style="min-width: 50px">{{ props.item.regKey}}</td>
                            <td  class="px-1 text-left" style="min-width: 120px">{{ $UtilityJs.AD2ROC_DateTime(props.item.effStartDate,'date')}}</td>
                            <td  class="px-1 text-left" style="min-width: 120px">{{ $UtilityJs.AD2ROC_DateTime(props.item.effEndDate,'date')}}</td>
                            <td  class="px-1 text-left" style="min-width: 120px">{{ props.item.regMemo}}</td>



                        </tr>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        第 {{ props.pageStart }} - {{ props.pageStop }} ,共 {{ props.itemsLength }} 筆
                    </template>
                    <template slot="no-data">

                        <v-alert :value='countDownNo>=5' type="warning" icon="mdi-alert-circle">
                            查詢中...
                        </v-alert>
                        <v-alert :value='tableAlert' color="info" icon="mdi-information">
                            表格中沒有內容
                        </v-alert>

                    </template>
                    <!--<v-alert slot="no-results" :value="true" color="info" icon="mdi-alert-circle">-->
                    <!--Your search for " {{ search }} " found no results.-->
                    <!--</v-alert>-->
                </v-data-table>
                <v-layout row wrap>
                    <v-flex xs12 md2>
                        <v-text-field
                                v-model="search"
                                class="ml-2 mt-2"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-flex>


                    <v-flex xs12 md6 text-center pt-2>
                        <v-pagination color="accent" v-model="pagination.page" :length="pagination.pageCount" :total-visible="7"></v-pagination>
                    </v-flex>
                    <v-flex xs6 md2 pt-2 pr-2 pl-2>
                        <v-select
                                :items="pageItem"
                                label="每頁筆數"
                                item-value="value"
                                v-model="pagination.rowsPerPage"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 md2 text-left pt-2 pr-2>
                        <v-text-field
                                label="總筆數"
                                v-model="regUserList.length"
                                readonly
                        ></v-text-field>
                    </v-flex>
                </v-layout>

            </v-flex>



        </v-card>

        <v-dialog v-model="editDialog"
                  eager
                  xs6 sm6 md6
                  :width="editDialogWidth+'%'"
                  value="false"
                  scrollable>
            <edit-reg-user   :is-show="editDialog" @closeDialog="closeDialog" @save="save" :edit-index="editIndex" :edit-obj="editObj"></edit-reg-user>
        </v-dialog>

        <v-dialog v-model="deleteDialog"
                  width="50%"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <delete-info-dialog @closeDelete="closeDelete" @confirmDelete="confirmDelete" :delete-title="deleteTitle" :delete-content="deleteContent"></delete-info-dialog>
        </v-dialog>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-flex>
</template>

<script>
    import EditRegUser from './EditRegUser'
    import DeleteInfoDialog from '../inursingsys/DeleteInfoDialog'
    export default {
        name: "RegUserMaintain",
        components: { DeleteInfoDialog,EditRegUser},
        data() {
            return {
                //程式功能清單
                countDownId: null, //data 定義一個定時器id
                countDownNo:0,
                tableAlert:false,
                regUserLoading:false,
                loadingText:'查詢中...',
                search:'',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                deleteDialog:false,
                deleteTitle:'刪除 網掛人員',
                deleteContent:'',
                deleteObj:{},
                editDialog:false,
                editIndex:-1,
                editObj:{},
                // regUserList: [],
                regUserList: [],
                pagination: {
                    sortBy: 'dataType',
                    rowsPerPage:100,
                    page: 1,
                    pageCount: 0,
                    descending:false
                },
                pageItem:[
                    {text:100,value:100},
                    {text:20,value:20},
                    {text:"All",value:-1},
                ],
                pageText:'每頁筆數 :',
                regUserHeaders:[
                    {
                        text: '',
                        align: 'center',
                        // value: 'assessDate'
                    },
                    {
                        text: '網掛人員代號',
                        // align: 'left',
                        value: 'regUserId',
                        class:'px-1'
                    },
                    {
                        text: '網掛人員名稱',
                        // align: 'center',
                        value: 'empName',
                        class:'px-1'
                    },
                    {
                        text: '檢查碼',
                        // align: 'center',
                        value: 'regKey',
                        class:'px-1'
                    },
                    {
                        text: '起始生效日期',
                        // align: 'left',
                        value: 'effStartDate',
                        class:'px-1'
                    },
                    {
                        text: '結束生效日期',
                        // align: 'left',
                        value: 'effEndDate',
                        class:'px-1'
                    },
                    {
                        text: '備註',
                        // align: 'left',
                        value: 'regMemo',
                        class:'px-1'
                    },


                ]
            }
        },
        created(){
                this.axios_getRegUserList();
        },
        computed:{
            menuInfo() {
                return this.$store.state.menuInfo;
            },

            editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {width = 100 }
                if(this.$vuetify.breakpoint.sm == true){width = 97}
                if(this.$vuetify.breakpoint.md == true){width =  60}
                if(this.$vuetify.breakpoint.lg == true){width =  50}
                if(this.$vuetify.breakpoint.xl ==true){width =  40}
                return width
            },

        },
        watch:{
        },
        methods:{
            countDown(){
                if(this.countDownId != null ) return;
                this.countDownId = setInterval(() => {
                    this.countDownNo++
                },1000)
            },
            //停止計時器
            stopCountDown(){
                clearInterval(this.countDownId);
                //當我清除定時器之後，重新讓countDownId為null , countDownNo歸零
                this.countDownId = null;
                this.countDownNo=0;
            },
            changeSort: function(column) {
                // console.log(column);
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false
                }
            },
            closeDelete(){
                this.deleteDialog = false;

            },
            confirmDelete(){
                this.axios_deleteRegUser(this.deleteObj);
            },
            transformUTC(utc,flag){ //uct->Date ; flag-> all,date,time
                let date =  this.$UtilityJs.AD2ROC_DateTime(utc,flag);
                return (date)
            },
            addItem(){  //新增按鈕
                this.editDialog = true;
                this.editIndex = -1;
            },
            closeDialog(){ //關閉編輯視窗
                this.editDialog = false;
            },
            editItem:function(item){
                this.editIndex = this.regUserList.indexOf(item);
                this.editObj = item;
                this.editDialog = true;
            },
            deleteItem:function(item){  //刪除
                this.deleteObj = item;
                this.deleteDialog = true;
                this.deleteContent = '確定要刪除，[網掛人員代號 '+item.regUserId+" / 網掛人員名稱"+item.regUserName+" / 檢查碼"+item.regKey+"]記錄";
            },
            save(item){
                if(this.editIndex==-1){ //新增
                    this.axios_postRegUser(item);
                }else { //修改
                    this.axios_putRegUser(item);
                }
            },
            resizeFunListGrid:function(){
                var userHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
                let height = userHeight-(270);
                let funListTable = document.getElementById('funListTable');
                funListTable.setAttribute('style','overflow-y: auto;min-height:'+height+'px;max-height:'+height+'px;');
            },
            axios_getRegUserList (){ //查詢網掛人員
                this.countDown();//開始計時
                this.regUserLoading = true;
                this.tableAlert = false;
                this.regUserList = [];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "ireguser/datasearch/primarykeys/ALL";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.regUserList = response.data.resultSet;
                    }else{
                        this.tableAlert = true;
                        this.regUserList = [];
                    }
                    this.regUserLoading = false;
                    this.stopCountDown();
                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.regUserList = [];
                    } catch(err) {
                        this.regUserList = [];
                    }
                    this.regUserLoading = false;
                    this.stopCountDown();
                });
            },

            axios_postRegUser(postData){ //新增 網掛人員
                let postList = [];
                postList.push(postData);
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "ireguser/";

                this.$http.post(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.editDialog = false;
                        this.axios_getRegUserList();


                        // this.search = response.data.resultSet[0].dataType
                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_putRegUser(putData){ //修改 網掛人員
                let postList = [];
                postList.push(putData);
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "ireguser/";

                this.$http.put(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.editDialog = false;
                        this.axios_getRegUserList();

                        // this.search = response.data.resultSet[0].dataType

                    }
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_deleteRegUser(item){   //刪除單筆資料
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "ireguser/s/"+item.regUserId;

                this.$http.delete(url).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.axios_getRegUserList();
                        this.deleteDialog = false;
                    }

                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>